import {FormBuilder_m10gaq1y1ibg4cs} from "./FormBuilder_m10gaq1y1ibg4cs";
import {FormBuilder_s10llatv0gxtgp9} from "./FormBuilder_s10llatv0gxtgp9";
import {FormBuilder_k4q9s5t01cuoje} from "./FormBuilder_k4q9s5t01cuoje";


/**
 * Return Popup builder instance based on requested form ID
 * @param {string} formId
 * @param {HTMLElement|undefined} trigger
 * @return {BasePopupFormBuilder}
 */
export function getFormBuilderForId(formId, trigger = undefined) {
    const submitText = trigger?.dataset.action || undefined
    switch (formId) {
        case 'm10gaq1y1ibg4cs':
            return new FormBuilder_m10gaq1y1ibg4cs({submitText});
        case 's10llatv0gxtgp9':
            return new FormBuilder_s10llatv0gxtgp9({submitText});
        case 'k4q9s5t01cuoje':
            return new FormBuilder_k4q9s5t01cuoje({submitText});
    }
}
